import React from 'react';
import styled from 'styled-components';
import { graphql } from 'gatsby';

import Layout from '../components/layout';
import SinglePost from '../components/blog/single-post';

const PostTemplateContainer = styled.div``;

const PostTemplate = ({ data, location }) => {
    return (
        <Layout>
            <PostTemplateContainer>
                <SinglePost
                    post={data.post.edges[0] && data.post.edges[0].node}
                />
            </PostTemplateContainer>
        </Layout>
    );
};

export default PostTemplate;

export const query = graphql`
    query($slug: String!) {
        post: allWpPost(filter: { slug: { eq: $slug } }) {
            edges {
                node {
                    title
                    excerpt
                    content
                    categories {
                        nodes {
                            slug
                            name
                        }
                    }
                    date(formatString: "MMMM Do, YYYY")
                    featuredImage {
                        node {
                            localFile {
                                childImageSharp {
                                    fluid(maxWidth: 1000) {
                                        ...GatsbyImageSharpFluid
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
